export default __webpack_public_path__ + "ac85aaeaae1f16522ab10af5f4fdbcd4.wav";